module.exports = __webpack_public_path__ + "static/img/wxapp_member_sport.21195c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/wxapp_member_sport.jpg
// module id = 1885
// module chunks = 0